import styled from 'styled-components';

import {
  useOrderFormActions,
  useOrderFormView,
} from '#/features/perpetuals/order-builder/form-context';

import Checkbox from '#/components/shared/Checkbox';

import useLabel from '#/utils/useLabel';

export default function PostOnlyCheckbox() {
  const formView = useOrderFormView();
  const formActions = useOrderFormActions();
  const [, labelId] = useLabel('post-only');

  return (
    <Label htmlFor={labelId}>
      <Checkbox
        checked={formView.isPostOnly}
        onCheckedChange={(checked) => formActions.updateIsPostOnly(checked)}
        id={labelId}
      />
      <LabelText checked={formView.isPostOnly}>Post Only</LabelText>
    </Label>
  );
}

const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
`;

const LabelText = styled.span<{ readonly checked: boolean }>`
  font-size: 12px;
  font-weight: 500;
  opacity: ${({ checked }) => (checked ? '1' : '0.7')};
`;
